import React from "react";
import "../../stylesheet/components/media/MediaInfo.scss";

const InfoSectionText: React.FC<{ label: string; body: string }> = ({
  label,
  body,
}) => {
  return (
    <div className="info-text">
      <p className="bold">{label}:</p>
      <p className="p2">{body}</p>
    </div>
  );
};

export default InfoSectionText;
